import * as TimeOffActionCreator from "./TimeOffActionCreator";


export function defaultTimeOffListState() {
  return {
    loading: false,
    response: null,
    error: null,
    page: 0,
    size: 10,
    startDate: null,
    endDate: null,
    sort: null
  };
}

export const TimeOffListReducer = (state, action) => {
  if (
    !state ||
    action.type === TimeOffActionCreator.TIMEOFF_ACTION.RESET_GET_TIMEOFF_REQUESTS_STATE
  ) {
    return { ...state, ...defaultTimeOffListState() };
  }

  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.REQUEST_GET_TIMEOFF_REQUESTS) {
    return {
      ...state,
      loading: true,
      page: action.data.page,
      size: action.data.size,
      startDate: action.data.startDate || state?.startDate || null,
      endDate: action.data.endDate || state?.endDate || null,
      sort: action.data.sort || state?.sort || null,
      response: null,
      error: null
    };
  }

  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.RESPONSE_GET_TIMEOFF_REQUESTS) {
    return { ...state, response: action.data, loading: false };
  }

  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.ERROR_GET_TIMEOFF_REQUESTS) {
    return {
      ...state,
      error: action.data,
      loading: false,
      response: null,
      page: 0,
      size: 10
    };
  }

  return state;
};





export function defaultGetTimeOffByIdState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}

export const GetTimeOffByIdReducer = (state, action) => {
  if (
    !state || action.type === TimeOffActionCreator.TIMEOFF_ACTION.RESET_GET_TIMEOFF_BY_ID_STATE
  ) {
    return { ...defaultGetTimeOffByIdState() };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.REQUEST_GET_TIMEOFF_BY_ID) {
    return { ...state, loading: true };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.RESPONSE_GET_TIMEOFF_BY_ID) {
    return { ...state, response: action.data, loading: false };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.ERROR_GET_TIMEOFF_BY_ID) {
    return { ...state, error: action.data, loading: false };
  }
  return state;
};

export function defaultUpdateTimeOffState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}

export const UpdateTimeOffReducer = (state, action) => {
  if (
    !state || action.type === TimeOffActionCreator.TIMEOFF_ACTION.RESET_UPDATE_TIMEOFF_STATE
  ) { 
    return { ...defaultUpdateTimeOffState() };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.REQUEST_UPDATE_TIMEOFF) {
    return { ...state, loading: true };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.RESPONSE_UPDATE_TIMEOFF) {
    return { ...state, response: action.data, loading: false };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.ERROR_UPDATE_TIMEOFF) {
    return { ...state, error: action.data, loading: false };
  }
  return state;
};

export function defaultCancelTimeOffState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}

export const CancelTimeOffReducer = (state, action) => {
  if (
    !state || action.type === TimeOffActionCreator.TIMEOFF_ACTION.RESET_CANCEL_TIMEOFF_STATE
  ) {
    return { ...defaultCancelTimeOffState() };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.REQUEST_CANCEL_TIMEOFF) {
    return { ...state, loading: true };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.RESPONSE_CANCEL_TIMEOFF) {
    return { ...state, response: action.data, loading: false };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.ERROR_CANCEL_TIMEOFF) {
    return { ...state, error: action.data, loading: false };
  }
  return state;
};


export function defaultRequestTimeOffRequestState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}

export const RequestTimeOffRequestReducer = (state, action) => {
  if (
    !state ||
    action.type === TimeOffActionCreator.TIMEOFF_ACTION.RESET_REQUEST_TIMEOFF_STATE
  ) {
    return { ...defaultRequestTimeOffRequestState() };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.REQUEST_REQUEST_TIMEOFF) {
    return { ...state, loading: true };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.RESPONSE_REQUEST_TIMEOFF) {
    return { ...state, response: action.data, loading: false };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.ERROR_REQUEST_TIMEOFF) {
    return { ...state, error: action.data, loading: false };
  }
  return state;
};

export function defaultGetAllTimeOffRequestsUsingUserIdState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}

export const GetAllTimeOffRequestsUsingUserIdReducer = (state, action) => {
  if (
    !state ||
    action.type === TimeOffActionCreator.TIMEOFF_ACTION.RESET_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID_STATE
  ) {
    return { ...defaultGetAllTimeOffRequestsUsingUserIdState() };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.REQUEST_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID) {
    return { ...state, loading: true };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.RESPONSE_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID) {
    return { ...state, response: action.data, loading: false };
  }
  if (action.type === TimeOffActionCreator.TIMEOFF_ACTION.ERROR_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID) {
    return { ...state, error: action.data, loading: false };
  }
  return state;
};
